export const labels = {
  start_date: "Start Date",
  completion_date: "Completion Date",
  title: "Title",
  conditions: "Conditions / Phenotypes",
  interventions: "Interventions",
  status: "Status",
  source: "Source",
  facilities: "Locations",
  pub_med_references: "Publications",
};

export const inProgress = [
  "Recruiting",
  "Available",
  "Enrolling by invitation",
  "Approved for marketing",
];

export const active = ["Active, not recruiting", "Not yet recruiting"];
